module.exports = __webpack_public_path__ + "static/img/4.1ed5f7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/4.png
// module id = c0TV
// module chunks = 0